import commonGame from '../commonGame';
import common from '../common';
import FillLayer from './FillLayer';
import DrawLayer from './DrawLayer';

const _onDrawMode_Changed = Symbol('_onDrawMode_Changed');

export default class Canvas extends PIXI.Container {
	constructor() {
		super();
		// Attributes.
		this._fillLayer = null;
		this._drawLayer = null;

		// Sprites.
		this._bgSprite = null;
		this._borderSprite = null;

		// Constants.
		this.WIDTH = commonGame.CANVAS_WIDTH;
		this.HEIGHT = commonGame.CANVAS_HEIGHT;
	}

	init() {
		// Bg.
		this.addChild(commonGame.createCanvasBg(common.levelConfig.gallery_select.frame.texture));

		this._bgSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
		this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._bgSprite.width = this.WIDTH;
		this._bgSprite.height = this.HEIGHT;
		this._bgSprite.tint = 0xffffff;

		this.addChild(this._bgSprite);

		// Border.
		this._borderSprite = new PIXI.Sprite(P3.assets.texture(
			common.levelConfig.gallery_select.frame[commonGame.selectedGallery === 1 ? 'colour_it' : 'draw_it']
		));
		this._borderSprite.anchor = new PIXI.Point(0.5, 0.5);
		//this._borderSprite.scale = new PIXI.Point(1.42, 1.45);
		this._borderSprite.width = this.WIDTH + 135;
		this._borderSprite.height = this.HEIGHT + 105;
		this.addChild(this._borderSprite);

		// Layers.
		// Fill.
		this._fillLayer = new FillLayer();
		this._fillLayer.init();
		this.addChild(this._fillLayer);
		// Draw.
		this._drawLayer = new DrawLayer();
		this._drawLayer.init();
		this.addChild(this._drawLayer);

		// Listen to HUD controls.
		common.game.hud.signals.onDrawModeChanged.add(this[_onDrawMode_Changed], this);

		// Start with the pencil
		this[_onDrawMode_Changed](commonGame.TOOL.PENCIL);

		this.alpha = 0;
		this.y -= 100;
		this._fillLayer.y += common.levelConfig.game_scene.outline_offset;
		this._drawLayer.y += common.levelConfig.game_scene.outline_offset;
	}

	animateIn() {
		new P3.utils.TWEEN.Tween(this, this.tweens)
		    .to({
		        y: this.y + 100,
				alpha: 1
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .onComplete(()=> {
				common.game.scene.addTutorialEvent(commonGame.TUT_EVENT.CANVAS_VISIBLE);
		    })
		    .start();
	}

	destroy(options) {
		super.destroy();
	}

	update() {
		this._fillLayer.update();
		this._drawLayer.update();
	}

	clear() {
		this._fillLayer.clear();
		this._drawLayer.clear();
	}

	[_onDrawMode_Changed](selection) {
		if (selection === commonGame.TOOL.PENCIL ||
			selection === commonGame.TOOL.BRUSH ||
			selection === commonGame.TOOL.SPRAY ||
			selection === commonGame.TOOL.STAMP ||
			selection === commonGame.TOOL.INK_POT ||
			selection === commonGame.TOOL.ERASER) {
			this._drawLayer.setEnabled(true);
			this._fillLayer.setEnabled(false);
		} else if (selection === commonGame.TOOL.BUCKET) {
			this._drawLayer.setEnabled(false);
			this._fillLayer.setEnabled(true);
		}

		// Sfx.
		P3.audio.playSound('sfx_tool_paintbrush_select_00');
	}

	get fillLayer() {
		return this._fillLayer;
	}

	get drawLayer() {
		return this._drawLayer;
	}
}
